// extracted by mini-css-extract-plugin
export default {"auditContainer":"FundraiserAuditStatus_auditContainer__Owo5e","title":"FundraiserAuditStatus_title__79M1e","statusContainer":"FundraiserAuditStatus_statusContainer__J3RJt"};